<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container-" v-if="!history">
      <div class="row-">
        <div class="col-12-">
          <div class="card- card-signup- no-shadow">
            <div
              class="card-header- card-header-primary negative blue-grad w-50"
            >
              <!-- <h4 class="card-title">{{$t('message.menu.account')}} | {{$t('message.account.topup_account')}}</h4> -->
            </div>
            <div class="card-bod-y px-3">
              <div class="row-">
                <!--offers-->
                <!-- <div class="col-12-">
									<div class="d-flex justify-content-between">
										<button class="btn btn-sm btn-link" @click="$router.go(-1)"><i class="fa fa-chevron-left"></i> {{$t('message.back')}}</button>
										<button class="btn btn-sm btn-outline-primary" @click="$bvModal.show('modal-history')">{{ $t('message.account.topup_history') }}</button>
									</div>
								</div> -->
                <div class="col-12-">
                  <div class="card- mb-5 mt-3">
                    <div class="card-body-">
                      <div class="row">
                        <div class="col-fifth">
                          <div>
                            <strong
                              >{{ $t("message.account.topup_step") }} 1.</strong
                            >
                          </div>
                          <div>
                            {{ $t("message.account.topup_step_1_title") }}
                          </div>
                          <div class="rub-input mt-5 mb-0 form-group">
                            <label for="">{{
                              $t("message.account.amount")
                            }}</label>
                            <cleave
                              v-model="amount"
                              :options="cleave_money"
                              class="form-control"
                              autocomplete="off"
                              style="cursor: auto"
                              id="amount"
                            ></cleave>

                            <!-- <input type="number" class="form-control" id="amount" v-model="amount" style="height: 32px;"> -->
                          </div>
                        </div>
                        <div class="col-fifth">
                          <div>
                            <strong
                              >{{ $t("message.account.topup_step") }} 2.</strong
                            >
                          </div>
                          <div>
                            {{ $t("message.account.topup_step_2_title") }}
                          </div>
                          <div class="mt-auto">
                            <button
                              @click="topupRequest"
                              class="btn btn-sm btn-primary"
                            >
                              {{ $t("message.account.topup") }}
                            </button>
                          </div>
                        </div>
                        <div class="col-fifth">
                          <div>
                            <strong
                              >{{ $t("message.account.topup_step") }} 3.</strong
                            >
                          </div>
                          <div>
                            {{ $t("message.account.topup_step_3_title") }}
                          </div>
                        </div>
                        <div class="col-fifth">
                          <div>
                            <strong
                              >{{ $t("message.account.topup_step") }} 4.</strong
                            >
                          </div>
                          <div>
                            {{ $t("message.account.topup_step_4_title") }}
                          </div>
                        </div>
                        <div class="col-fifth">
                          <div>
                            <strong
                              >{{ $t("message.account.topup_step") }} 5.</strong
                            >
                          </div>
                          <div>
                            {{ $t("message.account.topup_step_5_title") }}
                          </div>
                          <div class="mt-auto">
                            <span
                              class="btn btn-sm btn-primary"
                              @click="gotoaccount()"
                              >{{ $t("message.menu.account") }}</span
                            >
                          </div>
                        </div>
                      </div>
                      <!-- <button class="mt-4 btn btn-outline-success" :disabled="loading" @click="topupRequest">{{ $t('message.account.topup') }}</button> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="display: none" v-if="!history">
        <div id="invoice-history">
          <h4>{{ $t("message.account.topup_history") }}</h4>
          <table style="width: 100%" class="table table-striped table-bordered">
            <thead>
              <th>{{ $t("message.account.topup_history_operation") }}</th>
              <th>{{ $t("message.account.topup_amount") }}</th>
              <th>{{ $t("message.contracts.history_action_date") }}</th>
              <th>{{ $t("message.account.topup_history_service") }}</th>
            </thead>
            <tr v-for="row in history_list">
              <td>{{ renderServiceType(row.transaction_type) }}</td>
              <td>{{ rubFormat(row.transaction_amount) }}</td>
              <td>{{ row.transaction_date.replace("T", " ") }}</td>
              <td>{{ renderServiceName(row.transaction_service) }}</td>
            </tr>
          </table>
        </div>
        <div id="invoice-details">
          <table style="border-collapse: collapse; border: 1px solid #000">
            <tr>
              <td rowspan="2" colspan="2">
                <small
                  >АО «ForteBank» в г.Нур-Султан</small
                >
                <br />
                <br />
                <small>Банк получателя</small>
              </td>
              <td>
                <small>SWIFT</small>
              </td>
              <td rowspan="2">
                <small>IRTYKZKA</small>
                <br /><br />
                <small>990841000632</small>
              </td>
            </tr>
            <tr>
              <td>
                <small>БИН</small>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <small>БИН&nbsp;140940022635</small>
              </td>
              <td rowspan="2">
                <small>IBAN</small>
              </td>
              <td rowspan="2">
                <small>KZ5496503F0009668949</small>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <small>TОО «ATTIS Eurasia»</small>
                <br />
                <br />
                <small>Получатель</small>
              </td>
            </tr>
          </table>
          <br /><br />
          <h4>
            Счет на оплату № {{ invoice_number }} от {{ invoice_date }} г.
          </h4>
          <hr color="#000" />
          <table class="no-border">
            <tr>
              <td>
                <small> Поставщик (Исполнитель) </small>
              </td>
              <td>
                <strong>
                  Товарищество с ограниченной ответственностью «ATTIS Eurasia», 140940022635, Республика Казахстан, г. Нур-Султан, ул. Кунаева, 4
                </strong>
              </td>
            </tr>
            <tr>
              <td>
                <small> Покупатель (Заказчик) </small>
              </td>
              <td>
                <strong>
                  {{ current_user_details }}
                </strong>
              </td>
            </tr>
          </table>
          <div>
            <small> Основание: </small>
          </div>
          <table>
            <tr>
              <td><strong>№</strong></td>
              <td><strong>Артикул</strong></td>
              <td><strong>Товары (работы, услуги)</strong></td>
              <td><strong>Кол-во</strong></td>
              <td><strong>Ед.</strong></td>
              <td><strong>Цена</strong></td>
              <td><strong>Сумма</strong></td>
            </tr>
            <tr>
              <td><small>1</small></td>
              <td><small></small></td>
              <td><small>пополнение счета ЛК</small></td>
              <td><small></small></td>
              <td><small></small></td>
              <td>
                <small>{{ fixed(amount) }}</small>
              </td>
              <td>
                <small>{{ fixed(amount) }}</small>
              </td>
            </tr>
          </table>
          <div style="text-align: right; font-weight: bold">
            {{ fixed(amount) }}
          </div>
          <div style="text-align: right; font-weight: bold">-</div>
          <div style="text-align: right; font-weight: bold">
            {{ fixed(amount) }}
          </div>
          <div>
            <small>
              Всего наименований 1, на сумму {{ fixed(amount) }} tenge
            </small>
          </div>
          <div>
            <strong>
              {{ phrase(amount) }}
            </strong>
          </div>
          <br /><br />
          <div>
            <small>Оплатить не позднее {{ due_date }}</small>
          </div>
          <div>
            <small
              >Оплата данного счета означает согласие с условиями поставки
              товара.</small
            >
          </div>
          <div>
            <small
              >Уведомление об оплате обязательно, в противном случае не
              гарантируется наличие товара на складе.</small
            >
          </div>
          <br />
          <div>
            <small
              >Товар отпускается по факту прихода денег на р/с Поставщика,
              самовывозом, при наличии доверенности и паспорта.</small
            >
          </div>
          <hr />
          <div><strong>Руководитель: </strong>Блохина Н.</div>
          <div><strong>Бухгалтер:</strong></div>
        </div>
      </div>
    </div>
    <div class="card mt-5" v-if="history">
      <div class="card-header">
        <div class="d-flex justify-content-between align-items-center">
          <h4
            style="
              font-family: &quot;Roboto&quot;;
              font-style: normal;
              font-weight: 500;
              font-size: 20px;
              line-height: 24px;
              display: flex;
              align-items: center;
              color: #333333;
            "
          >
            {{ $t("message.account.topup_history") }}
          </h4>
          <div class="d-flex mb--3" style="gap: 10px">
            <button
              class="btn btn-sm btn-outline-secondary"
              @click="download_history"
            >
              <svg
                width="18"
                class="ml-1"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 2C12.5523 2 13 2.44772 13 3L13 12.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L11 12.5858L11 3C11 2.44772 11.4477 2 12 2ZM3 14C3.55228 14 4 14.4477 4 15L4 19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20L19 20C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19L20 15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15L22 19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22L5 22C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19L2 15C2 14.4477 2.44772 14 3 14Z"
                  fill="#333333"
                />
              </svg>
              PDF
            </button>
            <button
              class="btn btn-sm btn-outline-secondary"
              @click="download_history_xlsx"
            >
              <svg
                width="18"
                class="ml-1"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 2C12.5523 2 13 2.44772 13 3L13 12.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L11 12.5858L11 3C11 2.44772 11.4477 2 12 2ZM3 14C3.55228 14 4 14.4477 4 15L4 19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20L19 20C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19L20 15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15L22 19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22L5 22C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19L2 15C2 14.4477 2.44772 14 3 14Z"
                  fill="#333333"
                />
              </svg>
              Excel
            </button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive-mobile">
        <b-table responsive :fields="history_fields" :items="history_list">
          <template v-slot:cell(transaction_service)="data">
            {{ renderServiceName(data.value) }}
          </template>
          <template v-slot:cell(transaction_type)="data">
            {{ renderServiceType(data.value) }}
          </template>
          <template v-slot:cell(transaction_amount)="data">
            {{ rubFormat(data.value) }}
          </template>
          <!-- <template v-slot:cell(contract_date)="data">
						{{momentum(data.value)}}
					</template>
					<template v-slot:cell(buttons)="data">
						<div class="text-right"> -->
          <!--<button class="btn btn-sm btn-danger btn-round" @click="removeOffer(data.item, data.index)"><i class="fa fa-trash"></i></button>-->
          <!--<button class="btn btn-sm btn-info btn-round" @click="showModalOffer(data.item, data.index)"><i class="fa fa-eye"></i></button>
						</div>
					</template> -->
          <!-- <template v-slot:cell(buttons)="data">
						<button class="btn btn-link" @click="show_history_json(data)"><i class="fa fa-search"></i></button>
					</template> -->
        </b-table>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
// import html2pdf from 'html2pdf.js'
// import { jsPDF } from 'jspdf'
// import {PDFDocument} from 'pdf-lib'
// import HTMLtoDOCX from 'html-to-docx'

// import TableExport from 'tableexport'

var pdfMake = require("pdfmake/build/pdfmake");
var pdfFonts = require("pdfmake/build/vfs_fonts");
// var custom_font = require('../../vfs_fonts')
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    cn: {
    normal: "https://attistrade.kz/fonts/NotoSansSC-Regular.ttf",
    bold: "https://attistrade.kz/fonts/NotoSansSC-Regular.ttf",
    italics: "https://attistrade.kz/fonts/NotoSansSC-Regular.ttf",
    bolditalics: "https://attistrade.kz/fonts/NotoSansSC-Regular.ttf",
  },

  // download default Roboto font from cdnjs.com
  Roboto: {
    normal:
      "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
    bold: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
    italics:
      "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
    bolditalics:
      "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf",
  },
};

var htmlToPdfmake = require("html-to-pdfmake");
import moment from "moment";
export default {
  name: "topup-account",
  components: {},
  props: {
    history: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cleave_money: {
        numeral: true,
        numeralDecimalMark: ",",
        delimiter: " ",
      },

      service_codes: [
        { value: "1", display_text: this.$t("message.menu.comply_advantage") },
        {
          value: "430",
          display_text: this.$t("message.find_partner.common_info_cn"),
        },
        {
          value: "930",
          display_text: this.$t("message.find_partner.court_notice_info"),
        },
        {
          value: "701",
          display_text: this.$t("message.find_partner.corporate_news_search"),
        },
        {
          value: "213",
          display_text: this.$t("message.contragent_search.annual_report"),
        },
        {
          value: "736",
          display_text: this.$t(
            "message.contragent_search.enterprise_risk_scan",
          ),
        },
        {
          value: "886",
          display_text: this.$t("message.find_partner.fuzzy_search_cn"),
        },
      ],
      loading: false,
      amount: 0,
      invoice_number: "",
      history_fields: [
        // {
        // 	key: "buttons",
        // 	label: ''
        // },
        // {
        // 	key: "log_source_user_id",
        // 	label: this.$t('message.contracts.history_action_created_by')
        // },
        {
          key: "transaction_type",
          label: this.$t("message.account.topup_history_operation"),
          sortable: true,
        },
        {
          key: "transaction_amount",
          label: this.$t("message.account.topup_amount"),
          sortable: true,
        },
        {
          key: "transaction_date",
          label: this.$t("message.contracts.history_action_date"),
          sortable: true,
        },
        {
          key: "transaction_service",
          label: this.$t("message.account.topup_history_service"),
          sortable: true,
        },
      ],
      history_list: [],
    };
  },
  mounted() {
    this.load();
    if (this.$route.name == "topup-account-history") {
      this.$bvModal.show("modal-history");
    }
  },
  computed: {
    current_user_details() {
      let o = [];
      if (
        this.$store.state.firmfull &&
        this.$store.state.firmfull.organizations &&
        this.$store.state.firmfull.organizations.org_name
      )
        o.push(this.$store.state.firmfull.organizations.org_name);
      if (
        this.$store.state.firmfull &&
        this.$store.state.firmfull.organizations &&
        this.$store.state.firmfull.organizations.org_code
      )
        o.push("БИН " + this.$store.state.firmfull.organizations.org_code);

      if (
        this.$store.state.firmfull &&
        this.$store.state.firmfull.addresses &&
        this.$store.state.firmfull.addresses[0]
      ) {
        if (this.$store.state.firmfull.addresses[0].post_addr_index)
          o.push(this.$store.state.firmfull.addresses[0].post_addr_index);
        if (this.$store.state.firmfull.addresses[0].post_addr_district)
          o.push(this.$store.state.firmfull.addresses[0].post_addr_district);
        if (this.$store.state.firmfull.addresses[0].post_addr_region)
          o.push(this.$store.state.firmfull.addresses[0].post_addr_region);
        if (this.$store.state.firmfull.addresses[0].post_addr_city)
          o.push(this.$store.state.firmfull.addresses[0].post_addr_city);
        if (this.$store.state.firmfull.addresses[0].post_addr_streethouse)
          o.push(this.$store.state.firmfull.addresses[0].post_addr_streethouse);
        if (this.$store.state.firmfull.addresses[0].post_addr_house)
          o.push(this.$store.state.firmfull.addresses[0].post_addr_house);
        if (this.$store.state.firmfull.addresses[0].post_addr_room)
          o.push(
            "оф. " + this.$store.state.firmfull.addresses[0].post_addr_room,
          );
      }

      return o.join(", ");
    },
    due_date() {
      return moment().add(3, "day").format("DD.MM.YYYY");
    },
    invoice_date() {
      return moment().format("DD.MM.YYYY");
    },
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
        case "ru":
          locale = "ru-RU";
          break;
      }
      return locale;
    },
  },
  methods: {
    renderServiceType(str) {
      if (this.locale == "en-US") {
        switch (str) {
          case "списание":
            return "charge";
          case "пополнение":
            return "top-up";
        }
      }
      return str;
    },
    gotoaccount() {
      this.$root.$emit("goto-account-tab");
    },
    rubFormat(amount) {
      return window.rubFormat(amount);
    },
    download_history_xlsx() {
      var uri = "data:application/vnd.ms-excel;base64,",
        template =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64 = function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        };
      var toExcel = document.querySelector("#invoice-history table").innerHTML;
      var ctx = {
        worksheet: name || "",
        table: toExcel,
      };
      var link = document.createElement("a");
      link.download = "invoice-history.xls";
      link.href = uri + base64(format(template, ctx));
      link.click();
    },
    renderServiceName(codes) {
      let serv_codes = codes.split(",");
      let services = [];
      serv_codes.forEach((code) => {
        this.service_codes.forEach((item) => {
          if (item.value == code) {
            services.push(item.display_text);
          }
        });
      });
      return services.join(", ");
    },
    fixed(value) {
      let num = parseFloat(value);
      return num.toFixed(2);
    },
    phrase(value) {
      let num = parseFloat(value);
      return num.toPhrase("RUB");
    },
    normalGeneration(el) {},
    wrapChinese(str) {
      // const regex = /([\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f]{1,100})/g;
      // const regex = /([\p{Unified_Ideograph}\u3006\u3007][\ufe00-\ufe0f\u{e0100}-\u{e01ef}]?)/gmu;
      // const regex = /([\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\ud840-\ud868][\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|[\ud86a-\ud86c][\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d])/gmu;
      const regex = /(\p{Script=Han}{1,100})/gu;

      return str.replace(regex, `<span class="cn-symbol">$1</span>`);
    },
    async makePdf() {
      var element = document.getElementById("invoice-details");

      let images = element.querySelectorAll("img");
      await element.querySelectorAll(".table-responsive").forEach((res) => {
        res.classList.remove("table-responsive");
      });
      await element.querySelectorAll("table").forEach((res) => {
        res.style.breakWord = "break-all";
      });
      await images.forEach(async (image) => {
        if (image.src == "" || image.src == null) {
          console.log("tainted");
          image.remove();
        } else {
          let downloadedImg = new Image();
          downloadedImg.crossOrigin = "Anonymous";
          await downloadedImg.addEventListener(
            "load",
            (di) => {
              let canvas = document.createElement("canvas");
              canvas.width = downloadedImg.width;
              canvas.height = downloadedImg.height;
              let ctx = canvas.getContext("2d");
              ctx.drawImage(downloadedImg, 0, 0);
              let data = canvas.toDataURL("image/jpeg");
              console.log(data);
              image.alt = data;
              image.src = data;
            },
            false,
          );
          downloadedImg.src = image.src;
        }
      });
      setTimeout(() => {
        let dom = htmlToPdfmake(element.innerHTML, {
          tableAutoSize: true,
          ignoreStyles: ["font-family", "width"],
        });
        var dd = {
          content: dom,
        };
        pdfMake.createPdf(dd).download("invoice.pdf");
      }, 2000);
      // let div = element.querySelector(div)
      // element = document.querySelector('#invoice-details .table-responsive')
      // console.log(div.querySelectorAll('div'))
      var opt = {
        margin: [0.2, 0.1, 0.2, 0.1],
        filename: "invoice.pdf",
        enableLinks: false,
        //pagebreak:    { mode: 'css', avoid: 'p' },
        pagebreak: { mode: ["avoid-all", "css"] },
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      window.scrollTo(0, 0);
      // let docx = await HTMLtoDOCX(element.innerHTML, '', {}, '')
      // var url = window.URL || window.webkitURL;
      // var downloadUrl = url.createObjectURL(docx);

      // var a = document.createElement("a");
      // a.style.display = "none";

      // if (typeof a.download === "undefined") {
      // window.location = downloadUrl;
      // } else {
      // a.href = downloadUrl;
      // a.download = 'fileName.docx';
      // document.body.appendChild(a);
      // a.click();
      // }
      // let chunks = element.querySelectorAll('[data-pdf="chunk"]')
      // var doc = new jsPDF();
      // doc.html(element, {
      // 	callback: function (doc) {
      // 		doc.save();
      // 	},
      // 	x: 10,
      // 	y: 10
      // });
      // if(chunks.length>1){
      // 	let pdfs = []
      // 	let cross_pages = 1
      // 	Promise.all(Array.from(chunks).map(chunk=>{
      // 		new jsPDF().fromHTML(element).save()

      // 		// return html2pdf().from(chunk).set(opt).toPdf().output('arraybuffer')
      // 		// console.log(pdfs)
      // 	})).then(async r=>{
      // 			console.warn('1')
      // 			console.log(r)
      // 			let pdf = await PDFDocument.create();
      // 			await Promise.all(r.map(async r_=>{
      // 				const pdf_ = await PDFDocument.load(r_);
      // 				const copiedPages = await pdf.copyPages(pdf_, pdf_.getPageIndices());
      // 				copiedPages.forEach((page) => {
      // 					console.log('page', page.getWidth(), page.getHeight());
      // 					// page.setWidth(210);
      // 					pdf.addPage(page);
      // 				});
      // 			}))
      // 			let result = await pdf.saveAsBase64({ dataUri: true })
      // 			let a = document.createElement('a')
      // 			a.href = result
      // 			a.download = "pdf.pdf"
      // 			a.click()
      // 			// result = URL.createObjectURL(result)
      // 			console.log(result)
      // 		})
      // }else{
      // 	html2pdf().from(chunks[0]).set(opt).toPdf().get('pdf').then((pdf) => {
      // 		var totalPages = pdf.internal.getNumberOfPages();
      // 		//print current pdf width & height to consol
      // 		//var imgData = signature.toDataURL('image/png');
      // 		for (var i = 1; i <= totalPages; i++) {
      // 			pdf.setPage(i);
      // 			//if(type=='cmr')
      // 				// pdf.addImage(imgData, 'PNG', 12, pdf.internal.pageSize.getHeight()-40)
      // 			//else
      // 				//pdf.addImage(imgData, 'PNG', 0.59, pdf.internal.pageSize.getHeight()-1.37)
      // 			pdf.setFontSize(10);
      // 			pdf.setTextColor(150);
      // 			//divided by 2 to go center
      // 			// if(type=='cmr')
      // 			//     pdf.text(i + ' / ' + totalPages, pdf.internal.pageSize.getWidth()-24, pdf.internal.pageSize.getHeight()-30);
      // 			// else
      // 			//     pdf.text(i + ' / ' + totalPages, pdf.internal.pageSize.getWidth()-1.18, pdf.internal.pageSize.getHeight()-0.59);
      // 		}
      // 	}).save();
      // }
    },
    topupRequest() {
      /**
       * Generates invoice number, fills invoice with customer details, downloads invoice as PDF,
       * sends invoice details to backend
       */
      this.loading = true;
      this.invoice_number = "";
      axios
        .post(window.base + "/account/topupRequest", {
          amount: this.amount,
          user_id: this.$store.state.user.id,
        })
        .then((response) => {
          this.invoice_number = response.data.id;
          this.makePdf();
          this.load();
          this.loading = false;
        });
    },
    async download_history() {
      var element = document.getElementById("invoice-history");

      let images = element.querySelectorAll("img");
      await element.querySelectorAll(".table-responsive").forEach((res) => {
        res.classList.remove("table-responsive");
      });
      await element.querySelectorAll("table").forEach((res) => {
        res.style.breakWord = "break-all";
      });
      await images.forEach(async (image) => {
        if (image.src == "" || image.src == null) {
          console.log("tainted");
          image.remove();
        } else {
          let downloadedImg = new Image();
          downloadedImg.crossOrigin = "Anonymous";
          await downloadedImg.addEventListener(
            "load",
            (di) => {
              let canvas = document.createElement("canvas");
              canvas.width = downloadedImg.width;
              canvas.height = downloadedImg.height;
              let ctx = canvas.getContext("2d");
              ctx.drawImage(downloadedImg, 0, 0);
              let data = canvas.toDataURL("image/jpeg");
              console.log(data);
              image.alt = data;
              image.src = data;
            },
            false,
          );
          downloadedImg.src = image.src;
        }
      });
      setTimeout(() => {
        let dom = htmlToPdfmake(element.innerHTML, {
          tableAutoSize: true,
          ignoreStyles: ["font-family", "width"],
        });
        var dd = {
          content: dom,
          defaultStyle: {
            fontSize: 8,
            font: "Roboto",
          },
        };
        pdfMake.createPdf(dd).download("payment-history.pdf");
      }, 2000);
    },
    load() {
      /**
       * Loads history of balance toppings up
       * loads data from backend:
       * invoice, amount, log_date
       */
      axios
        .get(
          window.base +
            "/account/GetTopUps?user_id=" +
            this.$store.state.user.id,
        )
        .then((response) => {
          this.history_list = response.data;
        });
    },
  },
};
</script>
<style type="text/css">
.loading-map {
  background-image: url(data:image/gif;base64,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);
  background-repeat: no-repeat;
  background-position: center;
}

.vs--single .vs__selected {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
}
#person_map,
#company_map {
  overflow-x: hidden;
}

/**
		Validation
	*/
.validation-frame {
  position: fixed;
  background: white;
  height: auto;
  padding: 20px;
  box-sizing: border-box;
  box-shadow:
    0 16px 24px 2px rgb(0 0 0 / 14%),
    0 6px 30px 5px rgb(0 0 0 / 12%),
    0 8px 10px -5px rgb(0 0 0 / 20%);
  border-radius: 10px;
  z-index: 1231231231;
  transition: top 0.5s;
  max-height: calc(100vh - 100px);
}
.validation-frame .validation-frame-inner {
  max-height: calc(100vh - 140px);
  overflow: auto;
}
.validation-frame.arrow.top:before {
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 7.5px 10px 7.5px;
  border-color: transparent transparent #fff transparent;
  position: absolute;
  right: 20px;
  top: -5px;
}
.validation-frame.arrow.left:before {
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 15px 15px 0;
  border-color: transparent #fff transparent transparent;
  position: absolute;
  left: -8px;
  top: 0;
}
.validation-frame .btn.btn-link {
  position: absolute;
  right: -20px;
  top: -10px;
}
.form-group.error,
.row.error {
  /* background: rgba(255,0,0,.1); */
  padding: 10px;
  box-shadow: 0 2px 25px rgba(255, 0, 0, 0.1);
}
.form-group.error label,
.row.error label {
  color: #f44336;
}
.form-group.error .error-description,
.row.error .error-description {
  color: #f44336;
  font-size: 12px;
  font-style: italic;
  margin-top: 10px;
}
.form-group input[type="file"].form-control1 {
  position: static;
  opacity: 1;
}
.row .col-fifth {
  flex-basis: 20%;
  max-width: 20%;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
.row .col-fifth:last-child {
  border-right: 0;
}
#invoice-details table,
#invoice-details td {
  border: 1px solid #000;
  border-collapse: collapse;
}
#invoice-details table {
  width: 100%;
}
#invoice-details table.no-border,
#invoice-details table.no-border td {
  border: 0;
}
#invoice-details td {
  padding: 5px;
}
#invoice-details {
  width: 205mm;
  padding: 10mm;
}
.rub-input {
  position: relative;
}
.rub-input:after {
  content: "₸";
  position: absolute;
  right: 10px;
  top: 18px;
  font-size: 12px;
}
</style>
<style scoped>
.btn.btn-primary {
  display: inline-flex !important;
  flex-direction: row !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 16px !important;
  gap: 8px !important;

  height: 40px !important;

  /* attis/gradient light */

  background: linear-gradient(90deg, var(--color1) 0%, var(--color2) 100%) !important;
  border-radius: 8px !important;
  border: none !important;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  display: flex;
  align-items: center;
  letter-spacing: 0.1px;

  /* primary100 */

  color: #ffffff;
}
.col-fifth div {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */

  display: flex;
  align-items: center;
  letter-spacing: 0.25px;

  /* neutral/10 */

  color: #333333;
}
.col-fifth div strong {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height, or 120% */

  display: flex;
  align-items: center;

  /* attis/primary */

  color: #04416d;
  margin-bottom: 15px;
}
.form-group label {
  font-family: "Roboto";
  padding: 0 4px;
  background-color: #fff;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  position: absolute;
  left: 16px;
  z-index: 3;
  top: -8px;
  color: #797980;
}
.form-control:hover {
  border-color: #333333 !important;
  box-shadow: none !important;
}
.form-control:focus {
  border-color: var(--color2);
  box-shadow: none !important;
}
@media (max-width: 768px) {
  .card-body {
    overflow-x: auto;
  }
  .table-responsive-mobile {
    width: 100%;
    overflow-x: auto;
    min-width: 600px;
    -webkit-overflow-scrolling: touch;
  }
  .row .col-fifth {
    flex-basis: 100% !important;
    max-width: 100% !important;
    border-right: none !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 16px;
    padding-top: 16px;
  }
  .row {
    flex-direction: column !important;
    display: flex !important;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .row .col-fifth:last-child {
    border-bottom: 0 !important;
  }
}
</style>
